import React from 'react';
import {
  Breadcrumbs,
  ButtonBase,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function AppBreadCrumbs({ levelOne, levelTwo }) {
  const { palette } = useTheme();
  const navigate = useNavigate();

  return (
    <Stack direction="row" spacing={1}>
      <ButtonBase
        sx={{
          borderRadius: '50px',
          backgroundColor: palette.grey[200],
        }}
        onClick={() => navigate(-1)}
      >
        <ChevronLeftRounded color={palette.grey[500]} />
      </ButtonBase>
      <Breadcrumbs
        separator={<ChevronRightRounded fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ alignSelf: 'center' }}
      >
        {levelOne && (
        <Typography color="text.primary" sx={{ fontSize: 18 }}>
          {levelOne}
        </Typography>
        )}

        {levelTwo && (
        <Typography color="text.primary" sx={{ fontSize: 18 }}>
          {levelTwo}
        </Typography>
        )}
      </Breadcrumbs>
    </Stack>
  );
}

AppBreadCrumbs.propTypes = {
  levelOne: PropTypes.string,
  levelTwo: PropTypes.string,
};
